/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';

import { RecourseCampaignDetailsDto } from '../../models/recourse-campaign-details-dto';
import { RequestBuilder } from '../../request-builder';
import { StrictHttpResponse } from '../../strict-http-response';

export interface GetRecourseCampaignDetails$Params {
  recourseCampaignId: string;
}

export function getRecourseCampaignDetails(
  http: HttpClient,
  rootUrl: string,
  params: GetRecourseCampaignDetails$Params,
  context?: HttpContext,
): Observable<StrictHttpResponse<RecourseCampaignDetailsDto>> {
  const rb = new RequestBuilder(rootUrl, getRecourseCampaignDetails.PATH, 'get');
  if (params) {
    rb.path('recourseCampaignId', params.recourseCampaignId, {});
  }

  return http.request(rb.build({ responseType: 'json', accept: 'application/json', context })).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<RecourseCampaignDetailsDto>;
    }),
  );
}

getRecourseCampaignDetails.PATH = '/service/v1/recourseCampaign/recourseCampaignDetails/{recourseCampaignId}';
